// extracted by mini-css-extract-plugin
export default {"field":"percentField_field__aEOww"};